import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { forgotPassword } from "../../redux/slices/auth";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import "./ForgotPasswordForm.css";

const ForgotPasswordForm = () => {
  const dispatch = useDispatch();
  const { status } = useSelector((state) => state.auth);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Email is required"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        const result = await dispatch(forgotPassword(values));
        if (result.payload.success) {
          toast.success(result.payload.message);
        } else {
          toast.error(result.payload.message);
        }
      } catch (err) {
        toast.error("Failed to send reset instructions. Please try again.");
      }
    },
  });

  return (
    <section className="ForgotPasswordForm">
      <div className="forgot-password-form-wrapper">
        <form onSubmit={formik.handleSubmit}>
          <h3>Reset your Password</h3>
          <p>Enter your email address and we'll send you instructions to reset your password</p>

          {/* Email Field */}
          <div className="forgot-password-form-group">
            <input
              type="email"
              name="email"
              placeholder="Email"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              className={
                formik.touched.email && formik.errors.email ? "error" : ""
              }
            />
            {formik.touched.email && formik.errors.email && (
              <div className="error-message">
                <p>{formik.errors.email}</p>
              </div>
            )}
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={status === "loading" || formik.isSubmitting}
          >
            {status === "loading" ? "Sending..." : "Send Reset Instructions"}
          </button>

          {/* Back to Login Link */}
          <p className="back-to-login">
            Remember your password? <Link to="/login">Back to Login</Link>
          </p>
        </form>
      </div>
    </section>
  );
};

export default ForgotPasswordForm;